import WorkspaceSectionLayout from '../../components/WorkspaceSectionLayout';
import { messagesSubtabs } from '../../navigation';

const MessagesLayout = () => (
  <WorkspaceSectionLayout
    eyebrow="Messages"
    title="Messages"
    description="Connect WhatsApp Business, keep reply templates, and send automated reminders."
    ariaLabel="Messages sections"
    tabs={messagesSubtabs}
  />
);

export default MessagesLayout;
